export let insetObject = {
	orderId: "",
	customerName: "",
	orderStatus: "",
	orderSource: "",
	createdDate: ""
}

export let tableHeader = [
	// {
	// 	text: "Id",
	// 	value: "customerGuid",
	// 	align: "left"
	// },
	{
		text: "Id",
		value: "id",
		align: "left"
	},
	{
		text: "Meno",
		value: "firstname",
		align: "left"
	},
	{
		text: "Priezvisko",
		value: "lastname",
		align: "left"
	},
	{
		text: "Oddelenie",
		value: "department",
		align: "left"
	},
	{
		text: "Identita",
		value: "personIdentityName",
		align: "left"
	},
	{
		text: "Vytvorený",
		value: "created",
		align: "left"
	},
	{
		text: "",
		value: "action",
		sortable: false
	}
]